type Holiday = { date: Date; name: string };

export const getItalianHolidays = (year: number, city?: string): Holiday[] => {
  const holidays: Holiday[] = [];

  holidays.push(
    { date: new Date(year, 0, 1), name: 'Capodanno' },
    { date: new Date(year, 0, 6), name: 'Epifania' },
    { date: new Date(year, 3, 25), name: 'Giorno della liberazione' },
    { date: new Date(year, 4, 1), name: 'Festa dei lavoratori' },
    { date: new Date(year, 5, 2), name: 'Festa della repubblica' },
    { date: new Date(year, 7, 15), name: 'Ferragosto' },
    { date: new Date(year, 10, 1), name: 'Tutti i santi' },
    { date: new Date(year, 11, 8), name: 'Immacolata' },
    { date: new Date(year, 11, 25), name: 'Natale' },
    { date: new Date(year, 11, 26), name: 'Santo stefano' }
  );

  // Calculate Easter (moveable feast)
  const easter = calculateEaster(year);
  holidays.push({ date: easter, name: 'Pasqua' }, { date: new Date(easter.getTime() + 86400000), name: 'Pasquetta' });

  // Rome specific holidays (Feast of Saints Peter and Paul - June 29)
  if (city?.toLowerCase() === 'rome') {
    holidays.push({ date: new Date(year, 5, 29), name: 'San Pietro e Paolo' });
  }

  holidays.forEach(holiday => holiday.date.setHours(0, 0, 0, 0));

  return holidays;
};

export const calculateEaster = (year: number): Date => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  const easterDate = new Date(year, month, day);
  easterDate.setHours(0, 0, 0, 0);
  return easterDate;
};
